import { FormikContext } from 'formik'
import { BaseSyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { useFormik } from '../../../../../common/hooks/formik'
import { PureInput } from '../../../../../common/ui/pure-input/pure-input'
import { PureSwitcher } from '../../../../../common/ui/pure-switcher/pure-switcher'
import { useFBField } from '../../form-builder.context'
import { FormBuilderConfig } from '../../types/form-builder.types'

type DateRangeConfigProps = {
  label?: string
  from?: string
  to?: string
  required?: boolean
}

export const DateRangeConfig = ({ label, from, to, required = false }: DateRangeConfigProps) => {
  const { t } = useTranslation()
  const { value: configValue, setValue } = useFBField()
  const formik = useFormik<any>({
    initialValues: {
      label: label || '',
      from: from || '',
      to: to || '',
    },
    validationSchema: {},
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log('values', values)
    },
  })

  const handleChange = (key: string, value: BaseSyntheticEvent) => {
    setValue({ ...configValue, [key]: value.target.value } as unknown as FormBuilderConfig)
  }

  const handleSwitchChange = (key: string, value: boolean) => {
    setValue({ ...configValue, [key]: value } as unknown as FormBuilderConfig)
  }

  return (
    <FormikContext.Provider value={formik as any}>
      <form onSubmit={formik.handleSubmit}>
        <PureInput
          {...formik.getFieldProps('label')}
          name="name"
          onInput={(e) => handleChange('label', e)}
          placeholder={t('common.name')}
          size="small"
        />
        <PureInput
          {...formik.getFieldProps('from')}
          className="mt-2"
          name="placeholder"
          onInput={(e) => handleChange('from', e)}
          placeholder={t('common.from')}
          size="small"
        />
        <PureInput
          {...formik.getFieldProps('to')}
          className="mt-2"
          name="placeholder"
          onInput={(e) => handleChange('to', e)}
          placeholder={t('common.to')}
          size="small"
        />
        <hr />
        <PureSwitcher
          isChecked={required}
          label={[t('formBuilder.requiredForFill'), t('formBuilder.requiredForFill')]}
          onChange={(value) => handleSwitchChange('required', value)}
          position="left"
        />
      </form>
    </FormikContext.Provider>
  )
}
